// Disciplines
const disciplinesArr = [
  {
    code: 'running',
    code2: 'run',
    name: 'Бег',
    icon: 'running',
    color: '#36C597'
  },
  {
    code: 'walking',
    code2: 'walk',
    name: 'Ходьба',
    icon: 'walking',
    color: '#81D376'
  },
  {
    code: 'cycling',
    code2: 'cycling',
    name: 'Велозаезд',
    icon: 'cycling',
    color: '#FC5200'
  },
  {
    code: 'swimming',
    code2: 'swimming',
    name: 'Плавание',
    icon: 'swimming',
    color: '#0099FF'
  },
  {
    code: 'skiing',
    code2: 'skiing',
    name: 'Лыжи',
    icon: 'skiing',
    color: null
  }
]
const disciplinesObj = {}

for (let disciplineIndex = 0; disciplineIndex < disciplinesArr.length; disciplineIndex++) {
  disciplinesObj[disciplinesArr[disciplineIndex].code] = disciplinesArr[disciplineIndex]
}

const disciplinesMixin = {
  data () {
    return {
      disciplinesArr,
      disciplinesObj
    }
  }
}

// Sport types
const sportTypesArr = [
  {
    id: '4ca0bf31-d2c5-4325-8a2c-843892cd505e',
    name: 'Бег',
    adjective: 'Беговые',
    disciplines: [
      'running'
    ]
  },
  {
    id: '0c19764f-88c7-440f-94ff-873ab026c05f',
    name: 'Ходьба',
    adjective: 'Ходьбовые',
    disciplines: [
      'walking'
    ]
  },
  {
    id: 'd380834f-fbeb-411f-a565-ec38c547ef91',
    name: 'Трейл',
    adjective: 'Трейловые',
    disciplines: [
      'running'
    ]
  },
  {
    id: '89b5d179-9403-4b7a-ae64-b84124be3d13',
    name: 'Триатлон',
    adjective: 'Триатлонные',
    disciplines: [
      'running',
      'cycling',
      'swimming'
    ]
  },
  {
    id: '1e2df88c-5fdf-4fd1-825d-c33f9ba9dc31',
    name: 'Акватлон',
    adjective: 'Акватлонные',
    disciplines: [
      'running',
      'swimming'
    ]
  },
  {
    id: '56c43c0d-05c7-4108-a413-f09745801d57',
    name: 'Дуатлон',
    adjective: 'Дуатлонные',
    disciplines: [
      'running',
      'cycling'
    ]
  },
  {
    id: '65c7e23a-d9fc-4db1-9e62-09f587b92d53',
    name: 'Велоспорт',
    adjective: 'Велоспортивные',
    disciplines: [
      'cycling'
    ]
  },
  {
    id: 'e104a770-384e-4e4e-81df-f8709202eecf',
    name: 'Гонки с препятствиями',
    adjective: 'С препятствиями',
    disciplines: [
      'running'
    ]
  },
  {
    id: '62e7dc29-f8d9-4e53-bcfa-fa253c6371ec',
    name: 'Лыжные гонки',
    adjective: 'Лыжные',
    disciplines: [
      'skiing'
    ]
  },
  {
    id: '91a1f169-d2d9-4ef7-8365-6606bff83f62',
    name: 'Плавание',
    adjective: 'Плавательные',
    disciplines: [
      'swimming'
    ]
  },
  {
    id: '6dd08b3b-f46d-4a10-a1e6-0392beb9d3f5',
    name: 'Биатлон',
    adjective: 'Биатлонные',
    disciplines: [
      'skiing'
    ]
  }
]

const sportTypesObj = {}

for (let sportTypeIndex = 0; sportTypeIndex < sportTypesArr.length; sportTypeIndex++) {
  sportTypesObj[sportTypesArr[sportTypeIndex].id] = sportTypesArr[sportTypeIndex]
}

const sportTypesMixin = {
  data () {
    return {
      sportTypesArr,
      sportTypesObj
    }
  }
}

const sportTypesImages = {
  run: {
    icon: 'running',
    img: 'Content/redesign/pages/events/images/event-descipline/run-min.jpg',
    imgLg: 'Content/redesign/pages/events/images/event-descipline/run.jpg'
  },
  walk: {
    icon: 'walking'
  },
  'ski-race': {
    icon: 'skiing',
    img: 'Content/redesign/pages/events/images/event-descipline/ski-race-min.jpg',
    imgLg: 'Content/redesign/pages/events/images/event-descipline/ski-race.jpg'
  },
  swimming: {
    icon: 'swimming',
    img: 'Content/redesign/pages/events/images/event-descipline/swim-min.jpg',
    imgLg: 'Content/redesign/pages/events/images/event-descipline/swim.jpg'
  },
  cycling: {
    icon: 'cycling',
    img: 'Content/redesign/pages/events/images/event-descipline/cycle-min.jpg',
    imgLg: 'Content/redesign/pages/events/images/event-descipline/cycle.jpg'
  },
  snowboard: {
    icon: null,
    img: 'Content/redesign/pages/events/images/event-descipline/snowboard-min.jpg',
    imgLg: 'Content/redesign/pages/events/images/event-descipline/snowboard.jpg'
  },
  triathlon: {
    icon: null,
    img: 'Content/redesign/pages/events/images/event-descipline/triathlon-min.jpg',
    imgLg: 'Content/redesign/pages/events/images/event-descipline/triathlon.jpg'
  },
  obstacleracing: {
    icon: null,
    img: 'Content/redesign/pages/events/images/event-descipline/obstacleracing-min.jpg',
    imgLg: 'Content/redesign/pages/events/images/event-descipline/obstacleracing.jpg'
  },
  skiing: {
    icon: 'skiing',
    img: 'Content/redesign/pages/events/images/event-descipline/skiing-min.jpg',
    imgLg: 'Content/redesign/pages/events/images/event-descipline/skiing.jpg'
  },
  'sledge-sports': {
    icon: null,
    img: 'Content/redesign/pages/events/images/event-descipline/sledge-sports-min.jpg',
    imgLg: 'Content/redesign/pages/events/images/event-descipline/sledge-sports.jpg'
  },
  trail: {
    icon: 'running'
  }
}

const sportTypesImagesMixin = {
  data () {
    return {
      sportTypesImages
    }
  }
}

export {
  sportTypesMixin,
  disciplinesMixin,
  sportTypesImagesMixin
}
